import styled from 'styled-components'
import { ReactNode } from 'react'

interface TitleTextProps {
  children: ReactNode
}

const TitleText = styled.h1`
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-weight: 600;
  text-transform: capitalize;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.navyBlue};
  /* margin: 0; */

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    font-size: ${({ theme }) => theme.fontSize.xl};
  }
`

const TitleWrapper = ({ children }: TitleTextProps) => {
  return <TitleText>{children}</TitleText>
}

const GeneralTitle = styled(TitleText)`
  color: ${({ theme }) => theme.colors.navyBlue};
  padding-top: 10px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 24px;
`
const InvestmentTitleText = styled(TitleText)`
  color: ${({ theme }) => theme.colors.navyBlue};
  padding-top: 10px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 24px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    /* font-size: ${({ theme }) => theme.fontSize.x6}; */
  }
`
const ModalTitleText = styled(TitleText)`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: 600;
  /* line-height: 140%; */
  color: ${({ theme }) => theme.colors.navyBlue};
  font-size: ${({ theme }) => theme.fontSize.xl};
`
const LabelText = styled(TitleText)`
  font-style: normal;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding-bottom: 10px;
  color: ${({ theme }) => theme.colors.DarkCyan};
  font-size: ${({ theme }) => theme.fontSize.s};
`

const InvestmentDescText = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSize.xxl};
  color: ${({ theme }) => theme.colors.primary};
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    font-size: ${({ theme }) => theme.fontSize.s};
  }
`
const SettingTitleText = styled(TitleText)`
  /* font-size: ${({ theme }) => theme.fontSize.xx2};
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    font-size: 24px;
  } */

  color: ${({ theme }) => theme.colors.navyBlue};
  padding-top: 10px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 24px;
  margin-bottom: 2rem;
`
const CollaboTitleText = styled(TitleText)`
  color: ${({ theme }) => theme.colors.navyBlue};
  padding-top: 10px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  /* margin: 2rem 0; */
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 24px;
`
const InvestTitleText = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSize.xx2};
  color: ${({ theme }) => theme.colors.stillSellingColor};
  font-weight: bold;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    font-size: ${({ theme }) => theme.fontSize.x6};
  }
`
const NameText = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSize.xxl};
  color: ${({ theme }) => theme.colors.dark};
  text-align: center;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    font-size: ${({ theme }) => theme.fontSize.x2};
  }
`
// const TargetTitle = styled(TitleText)`
//   color: ${({ theme }) => theme.colors.successGreen};
//   padding-top: 10px;
//   margin: 0;
// `
const EmergencyTitle = styled(TitleText)`
  color: ${({ theme }) => theme.colors.navyBlue};
  padding-top: 10px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 24px;
`

const XcontestTitle = styled(EmergencyTitle)`
  /* text-transform: capitalize; */
  text-transform: lowercase;

  &::first-letter {
    text-transform: capitalize;
  }
`

const TargetTitle = styled(EmergencyTitle)`
  /* color: ${({ theme }) => theme.colors.TargetColor}; */
  padding-top: 10px;
  margin: 0;
`

const TransactionTitleText = styled(TitleText)`
  font-style: normal;
  font-size: ${({ theme }) => theme.fontSize.s};
  color: ${({ theme }) => theme.colors.transactionColor};
  font-family: ${({ theme }) => theme.fontFamily.inter};
  text-align: center;
  cursor: pointer;
  font-weight: 600;
`
const CollaboDescText = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSize.xx2};
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 500;
  padding-top: 23px;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    font-size: ${({ theme }) => theme.fontSize.x5};
  }
`
const CollaboInviteText = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSize.xx2};
  color: ${({ theme }) => theme.colors.CollaboBlue};
  font-weight: 500;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    font-size: ${({ theme }) => theme.fontSize.x2};
  }
`
const AddCardModalText = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSize.x1};
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 700;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    font-size: ${({ theme }) => theme.fontSize.x2};
  }
`

const SubTitleText = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSize.xx2};
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 500;
`

const BankTransferText = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSize.xx2};
  color: ${({ theme }) => theme.colors.stillSellingColor};
  font-weight: bold;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    font-size: ${({ theme }) => theme.fontSize.x6};
  }
`

const OnboardingText = styled(TitleText)`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.navyBlue};
  font-size: 36px;
  margin: 0;
`

const ContestModalTitle = styled(TitleText)`
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.xxl};
  color: ${({ theme }) => theme.colors.black};
`

export {
  TitleWrapper,
  InvestmentTitleText,
  InvestmentDescText,
  TransactionTitleText,
  NameText,
  SettingTitleText,
  CollaboTitleText,
  CollaboDescText,
  CollaboInviteText,
  InvestTitleText,
  GeneralTitle,
  TargetTitle,
  EmergencyTitle,
  AddCardModalText,
  SubTitleText,
  BankTransferText,
  OnboardingText,
  ModalTitleText,
  LabelText,
  XcontestTitle,
  ContestModalTitle,
}
